import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@material-ui/core";
import React from "react";
import { useTranslation } from "react-i18next";

// Update Password
export default function PasswordModal(props: any) {
  const currentPassword = React.createRef<HTMLInputElement>();
  const newPassword = React.createRef<HTMLInputElement>();
  const confirmPassword = React.createRef<HTMLInputElement>();
  const [disabled, setDisabled] = React.useState<boolean>(true);
  const { t } = useTranslation();
  const handleErrors = (e: React.ChangeEvent<HTMLInputElement>) => {
    const formErrors = e.currentTarget.nextSibling as HTMLSpanElement;
    const inputName = e.currentTarget.name;
    const inputValue = e.currentTarget.value;
    if (
      currentPassword.current === null ||
      newPassword.current === null ||
      confirmPassword.current === null
    )
      return;
    if (!inputValue || inputValue === "")
      return (
        (formErrors.innerText = `${t(`${inputName.replace("_", " ")} is required.`)}`),
        e.currentTarget.classList.toggle("is-invalid", true),
        e.currentTarget.classList.toggle("is-valid", false),
        setDisabled(true)
      );
    switch (inputName) {
      case "current_password":
        if (inputValue.length < 8 || !/[a-zA-Z0-9]/i.test(inputValue)) {
          return (
            (formErrors.innerText = `${t(`${inputName.replace("_", " ")} is invalid`)}`),
            e.currentTarget.classList.toggle("is-invalid", true),
            e.currentTarget.classList.toggle("is-valid", false),
            setDisabled(true)
          );
        }
        break;
      case "new_password":
        if (!currentPassword.current || !newPassword.current) return;
        if (currentPassword.current.value === inputValue) {
          return (
            (formErrors.innerText = `${t(
              `${inputName.replace("_", " ")} should not be the same as current password`
            )}`),
            e.currentTarget.classList.toggle("is-invalid", true),
            e.currentTarget.classList.toggle("is-valid", false),
            setDisabled(true)
          );
        }
        if (inputValue.length < 8 || !/[a-zA-Z0-9]/i.test(inputValue)) {
          return (
            (formErrors.innerText = `${t(`${inputName.replace("_", " ")} is invalid`)}`),
            e.currentTarget.classList.toggle("is-invalid", true),
            e.currentTarget.classList.toggle("is-valid", false),
            setDisabled(true)
          );
        }
        break;
      case "confirm_password":
        if (!newPassword.current || !confirmPassword.current) return;
        if (newPassword.current.value !== inputValue) {
          return (
            (formErrors.innerText = `${t(`Passwords do not match`)}`),
            e.currentTarget.classList.toggle("is-invalid", true),
            e.currentTarget.classList.toggle("is-valid", false),
            setDisabled(true)
          );
        }
        if (inputValue.length < 8 || !/[a-zA-Z0-9]/i.test(inputValue)) {
          return (
            (formErrors.innerText = `${t(`${inputName.replace("_", " ")} is invalid`)}`),
            e.currentTarget.classList.toggle("is-invalid", true),
            e.currentTarget.classList.toggle("is-valid", false),
            setDisabled(true)
          );
        }
        break;
      default:
        break;
    }
    return (
      (formErrors.innerText = ""),
      e.currentTarget.classList.toggle("is-invalid", false),
      e.currentTarget.classList.toggle("is-valid", true),
      currentPassword.current.classList.contains("is-valid") &&
        newPassword.current.classList.contains("is-valid") &&
        confirmPassword.current.classList.contains("is-valid") &&
        setDisabled(false)
    );
  };

  return (
    <Dialog {...props}>
      <DialogTitle
        style={{
          backgroundColor: "var(--text-primary)",
          color: "#ffffff",
          height: 65,
        }}
      >
        {t("Change password")}
      </DialogTitle>
      <hr />
      <DialogContent style={{ padding: "12px 24px" }}>
        <form
          onSubmit={(e) =>
            currentPassword.current &&
            newPassword.current &&
            confirmPassword.current &&
            newPassword.current.value === confirmPassword.current.value &&
            props.onSubmit(e, {
              currentPassword: currentPassword.current.value,
              newPassword: newPassword.current.value,
            })
          }
          onReset={props.onClose}
          name={"password"}
        >
          <div className={"form-row"}>
            <label className={"form-label"}>{t("Current password")}</label>
            <input
              className={"form-control"}
              type="password"
              name="current_password"
              ref={currentPassword}
              required
              title=""
              onChange={handleErrors}
            />
            <span className="form-errors"></span>
          </div>
          <div className={"form-row"}>
            <label className={"form-label"}>{t("New password")}</label>
            <input
              className={"form-control"}
              type="password"
              name="new_password"
              ref={newPassword}
              required
              title=""
              onChange={handleErrors}
            />
            <span className="form-errors"></span>
          </div>
          <div className={"form-row"}>
            <label className={"form-label"}>{t("Retype new password")}</label>
            <input
              className={"form-control"}
              type="password"
              name="confirm_password"
              ref={confirmPassword}
              required
              title=""
              onChange={handleErrors}
            />
            <span className="form-errors"></span>
          </div>
          <DialogActions style={{ marginTop: 15 }}>
            <Button
              type="reset"
              variant="contained"
              color="primary"
              style={{
                backgroundColor: "#333333",
                textTransform: "capitalize",
              }}
            >
              {t("Cancel")}
            </Button>
            <Button
              type="submit"
              disabled={disabled}
              variant="contained"
              color="primary"
              style={{
                backgroundColor: "var(--text-primary)",
                color: "#ffffff",
                textTransform: "none",
              }}
            >
              {t("Save")}
            </Button>
          </DialogActions>
        </form>
      </DialogContent>
    </Dialog>
  );
}
